/**
 * @file
 * Provide several helper functions for displaying d3-charts
 */

/**
 * Set color by voting-behavior
 *
 * @param {Array} data
 *   Containing the voting behaviors in a array.
 *
 * @returns {String}
 *   The color of the voting behavior.
 */

Drupal.chartColorsByVote = function (data) {
  let color = '';
  switch (data) {
    case 'yes':
      color = color_green;
      break;
    case 'no':
      color = color_red;
      break;
    case 'abstain':
      color = color_gray_light;
      break;
    case 'no_show':
      color = color_gray;
      break;
  }
  return color;
};

/**
 * Set label by voting-behavior key
 *
 * @param {Array} data
 *   Containing the voting behavior keys in a array.
 *
 * @returns {String}
 *   The translatable label of the voting behavior.
 */
Drupal.voteBehaviorLabel = function (data) {
  let label = '';

  switch (data) {
    case 'yes':
      label = Drupal.t('Voted in favor');
      break;
    case 'no':
      label = Drupal.t('Voted against');
      break;
    case 'abstain':
      label = Drupal.t('Abstained');
      break;
    case 'no_show':
      label = Drupal.t('Did not vote');
      break;
  }
  return label;
};
